export interface WrapperMessage {
    operator: OperatorData;
    data: any;
}

export enum Action {
    enableAudio = "enableAudio",
    disableAudio = "disableAudio",
    updateBalance = "updateBalance",
    getOperatorInformation = "getOperatorInformation",
    balanceTooLow = "balanceTooLow",
    isWrapperActive = "isWrapperActive",
    getScreenSize = "getScreenSize",
    balancesHasChanged = "balancesHasChanged",
    pauseGame = "pauseGame",
    resumeGame = "resumeGame",
    wrapperActivityChanged = "wrapperActivityChanged",
    gameLoadingStarted = "gameLoadingStarted",
    gameLoadingEnded = "gameLoadingEnded",
    stakeUpdate = "stakeUpdate",
    balancesUpdate = "balancesUpdate",
    winningsUpdate = "winningsUpdate",
    loadProgressUpdate = "loadProgressUpdate",
    gameRoundEnded = "gameRoundEnded",
    gotoDepositPage = "gotoDepositPage",
    gotoAccountsPage = "gotoAccountsPage",
    gameRoundStarted = "gameRoundStarted",
    exitGame = "exitGame",
    openPaytable = "openPaytable",
    openHelp = "openHelp",
    openPreferences = "openPreferences",
    openAbout = "openAbout",
    insufficientFunds = "insufficientFunds",
    gamePopupShown = "gamePopupShown",
    gamePopupHidden = "gamePopupHidden"
}

export enum UiElements {
    homeButton = "homeButton",
    depositPageButton = "depositPageButton",
    accountsButton = "accountsPageButton"
}

export enum UiDenomDisplayType {
    denom = "denom",
    multiplier = "multiplier"
}

export interface OperatorData {
    operator: {
        id: number;
        name: string;
    };
    ui: Ui;
}

export interface Ui {
    layouts: Layouts;
    maxBet: string;
    denomDisplay: UiDenomDisplayType;
    autoplay: AGSAutoplayConfigSchema;
    slamStop: string;
    displayClock: string;
    minStopDuration: number;
    hideJackpotWording: string;
    disableFullscreen: boolean;
    displayType: string;
}
export interface Layouts {
    mobile: UiElements[];
    desktop: UiElements[];
}

export interface AGSAutoplayConfigSchema {
    stopOnFeatureWin: boolean;
    numberOfRounds: AGSArrayWithDefaultConfigSchema;
    lossLimit: AGSArrayWithDefaultConfigSchema;
    totalWinLimit: AGSArrayWithDefaultConfigSchema;
    singleWinLimit: AGSArrayWithDefaultConfigSchema;
}

export interface AGSArrayWithDefaultConfigSchema {
    defaultVal: number;
    values: number[];
    lossLimitRequired: boolean;
}
